import { eaCollectorWrapper, dataLayerGAWrapper } from '../utils/taggingPlan';
import { getHost } from '../app';
import { getEnv } from '../utils/environment';

document.addEventListener("DOMContentLoaded", () => {
    eaCollectorWrapper([
        'rtgsite', 'professionnel',
        'rtgpg', 'hp',
        'rtgpagename', 'homepage',
        'path', window.location.pathname,
        'from', getHost()
    ]);

    dataLayerGAWrapper({
        page_type: 'Homepage', 
        environment: getEnv(),
        error: ''
    });
}, false );